export default __webpack_public_path__ + "static/media/bgP.b61b9e4e.webp";